import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "@/components/ui/Spinner";

export default function AuthVerify() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Il backend redirige a /auth/verify#token=<jwt>&to=<target>
    // Leggi il fragment, salva il JWT, naviga al target. NIENTE network call.
    const hash = window.location.hash.replace(/^#/, "");
    if (!hash) {
      setError("Link non valido. Richiedine uno nuovo.");
      return;
    }
    const params = new URLSearchParams(hash);
    const token = params.get("token");
    const to = params.get("to") ?? "/area";
    if (!token) {
      setError("Token mancante nel link.");
      return;
    }
    localStorage.setItem("jwt", token);
    // Cancella il fragment (no token persistito nell'URL)
    window.history.replaceState(null, "", window.location.pathname);
    navigate(to, { replace: true });
  }, [navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4">
        <div className="text-center space-y-3">
          <div className="text-4xl">⚠️</div>
          <p className="text-secondary">{error}</p>
          <a href="/accedi" className="text-accent underline font-mono text-sm">
            Richiedi nuovo link
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center space-y-3">
        <Spinner size={32} />
        <p className="text-secondary font-mono text-sm">Accesso in corso…</p>
      </div>
    </div>
  );
}
